/**
 * Predefined Gradient Presets
 * For background customizer in light theme
 */
export const gradientPresets = [
  {
    name: 'Sunset',
    value: 'bg-gradient-to-br from-orange-200 via-pink-200 to-purple-200',
  },
  {
    name: 'Ocean',
    value: 'bg-gradient-to-br from-blue-200 via-cyan-200 to-teal-200',
  },
  {
    name: 'Forest',
    value: 'bg-gradient-to-br from-green-200 via-emerald-200 to-teal-200',
  },
  {
    name: 'Lavender',
    value: 'bg-gradient-to-br from-purple-200 via-violet-200 to-pink-200',
  },
  {
    name: 'Peach',
    value: 'bg-gradient-to-br from-orange-100 via-amber-100 to-yellow-100',
  },
  {
    name: 'Mint',
    value: 'bg-gradient-to-br from-teal-100 via-cyan-100 to-blue-100',
  },
]
